import React, { useEffect, } from 'react';
import { Modal, } from 'react-bootstrap';

import { awaitDelay, dataTableLanguaje, globalSettings, isUndNullEmp, languageObjGet, responseGet, sendMessageCloseCurrentWindowAsync, styles, } from '../../helpers/settings';
import { expenseTemplateModelGet } from '../../models/expenses/template';
import { GlobalFormats } from '../../classes/main/globalFormats';
import { receiptModelGet } from '../../models/receipts/receipt';
const currentMethod = 'ExpenseTemplateAdd';

export default function ExpenseTemplateAdd({
    $ = {},
    auth = {},
    expenseTemplatesDt = '',
    expenseTemplates = [expenseTemplateModelGet({})],
    setExpenseTemplate = () => { },
    receipt = receiptModelGet({}),
    setReceipt = () => { },
    showModal = false,
    setShowModal = () => { },
    processType = 0,
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region variables
    const dtTemplatesId = 'dtTemplatesId';
    //#endregion variables

    //#region others
    const controls = {
        buttons: {
            back: {
                id: 'btnModalExpenseTemplateAddBack',
                className: 'btn btn-outline-success mx-1',
            },
            close: {
                id: 'btnModalExpenseTemplateAddClose',
                className: 'close btn-danger fas fa-window-close',
            },
        },
        checkBox: {
            // remenberMe: {
            //     attributes: {
            //     },
            //     id: 'chkRemenberMe',
            // },
        },
        dataTables: {
            expenseTemplates: {
                buttons: {
                    // create: {
                    //     className: 'btn btn-outline-success float-right btn-sm mx-1',
                    //     id: 'btnDtSuppliersCreate',
                    // },
                },
                icons: {
                    // create: {
                    //     id: 'iconDtSuppliersCreate',
                    //     className: globalSettings?.icons?.plusCircle,
                    // },
                },
                inputs: {
                    search: {
                        id: `${dtTemplatesId}_filter input`,
                        className: '',
                    },
                },
                selects: {
                    entries: {
                        id: `${dtTemplatesId}_length select`,
                        className: '',
                    },
                },
                spinners: {
                    // create: {
                    //     id: 'spDtSuppliersCreate',
                    //     className: '',
                    // },
                },
            },
        },
        icons: {
            back: {
                id: 'icoModalExpenseTemplateAddBack',
                className: globalSettings?.icons?.arrowCircleLeft,
            },
            close: {
                id: 'icoModalExpenseTemplateAddClose',
                className: globalSettings?.icons?.fasFa?.lok,
            },
        },
        inputs: {
            // number: {
            //     id: 'inputNumber',
            //     //className: 'form-control bg-transparent text-black',
            //     className: 'form-control',
            // },
            // description: {
            //     id: 'inputDescription',
            //     //className: 'form-control bg-transparent text-black',
            //     className: 'form-control',
            // },
        },
        selects: {
            // apartment: {
            //     id: 'selApartmet',
            //     className: 'form-select',
            // },
            // title: {
            //     id: 'selTitle',
            //     className: 'form-select',
            // },
            // icon: {
            //     id: 'selIcon',
            //     className: 'form-select',
            // },
            // status: {
            //     id: 'selStatus',
            //     className: 'form-select',
            // },
        },
        spinners: {
            back: {
                id: 'spModalExpenseTemplateAddBack',
                className: '',
            },
            close: {
                id: 'spModalExpenseTemplateAddClose',
                className: '',
            },
        },
        urls: {
            // forgotYourPassword: {
            //     id: 'urlForgotYourPassword',
            //     className: 'btn-link',
            // },
            // reCaptchaPrivaciConditions: {
            //     id: 'urlReCaptchaPrivaciConditions',
            //     className: '',
            // },
            // userRegister: {
            //     id: 'urlRequestAccount',
            //     className: '',
            // },
            // registerStatus: {
            //     id: 'urlStatusRegister',
            //     className: '',
            // },
        },
    };
    //#endregion others

    //#region methods
    const dataGetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataGetAsync';
        let response = responseGet();
        try {
            //#region dataTable set
            response = await dataTablesSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                await defaultValueSetAsync({
                    isModalClose: true,
                    subMethod: currentMethod
                });
                return;
            }
            //#endregion dataTable set

            //#region data in dataTable set
            $(`#${dtTemplatesId}`)?.DataTable()?.rows?.add(expenseTemplatesDt)?.draw();
            //#endregion data in dataTable set
        } catch (ex) {
            setShowModal(false);
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const defaultValueSetAsync = async ({ isModalClose = false, subMethod = '', }) => {
        const currentMethod = 'defaultValueSetAsync';
        let response = responseGet();
        try {
            if (isModalClose) {
                controlsStatusSet({ processType: 1, subMethod: currentMethod, });
                await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            }
            setShowModal(!isModalClose);
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const dataTablesSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataTablesSetAsync';
        let response = responseGet();
        try {
            //#region dataTable set
            $(`#${dtTemplatesId}`)?.DataTable({
                columns: [
                    { title: globalSettings?.labels?.date?.[languageObj?.id], width: '0%', searchable: false, visible: false, },
                    { title: globalSettings?.labels?.description?.[languageObj?.id], width: '65%', },
                    { title: globalSettings?.labels?.date?.[languageObj?.id], width: '10%', orderable: false, },
                    { title: globalSettings?.labels?.balance?.[languageObj?.id], className: 'text-right', width: '20%', },
                    { title: globalSettings?.labels?.process?.[languageObj?.id], className: 'text-center', width: '5%', orderable: false, searchable: false, },
                ],
                //data: expenseTemplatesDt,
                data: [],
                destroy: true,
                language: dataTableLanguaje({ languageId: languageObj?.id, subMethod: currentMethod, }),
                //order: [[1, 'asc'], [0, 'asc']],
                //order: [[1, 'desc'],],
                order: [[0, 'desc'],],
                responsive: true,
                lengthChange: true,
                autoWidth: false,
            });
            //#endregion dataTable set

            //#region query code set
            response = await queryCodeSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }
            //#endregion query code set
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const expenseTemplateSetAsync = async ({ expenseTemplateId = '', subMethod = '', }) => {
        let response = responseGet();
        const currentMethod = 'expenseTemplateSetAsync';
        try {
            //#region variables
            const expenseTemplateLocal = expenseTemplates?.find(({ id }) => id === expenseTemplateId) || {};
            //#endregion variables

            //#region methods
            if (!isUndNullEmp({ data: expenseTemplateLocal, subMethod: currentMethod, })?.result) {
                setExpenseTemplate(expenseTemplateLocal);
                setReceipt({
                    ...receipt,
                    [globalSettings?.collections?.properties?.expenseTemplateId]: expenseTemplateId,
                });
            } else {
                setExpenseTemplate(
                    expenseTemplateModelGet({
                        buildingId: '',
                        userId: auth?.user?.uid,
                    })
                );
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const queryCodeSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'queryCodeSetAsync';
        let response = responseGet();
        try {
            //#region variables
            let rowIndex = '';
            let isCheckedLocal = '';
            let expenseTemplateId = '';
            //#endregion variables

            //#region methods
            $(`#${dtTemplatesId} tbody`)?.on('click', 'tr', 'td', function (e) {
                // Get index rox (DataTable)
                rowIndex = $(`#${dtTemplatesId}`)?.DataTable()?.row(this)?.index();
                if (!isUndNullEmp({ data: rowIndex, subMethod: currentMethod, })?.result) {
                    expenseTemplateId = e?.target?.attributes?.id?.value || '';
                    isCheckedLocal = e?.target?.checked || false;
                    if (!isUndNullEmp({ data: expenseTemplateId, subMethod: currentMethod, })?.result) {
                        switch (isCheckedLocal) {
                            case true:
                                expenseTemplateSetAsync({
                                    expenseTemplateId: expenseTemplateId,
                                    subMethod: currentMethod,
                                });
                                break;
                            default:
                                // conceptsChecked = conceptsChecked.filter(({id}) => id !== expenseTemplateId);
                                break;
                        }
                    }
                }
            });
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    //#region Old code
    // const localExpenseTemplateAddPostAsync = (e) => {
    //     try{
    //         e.preventDefault();

    //         if(isUndefined(expenseTemplate) || isNull(expenseTemplate)){
    //             sendMessage(1, globalSettings?.messages?.youMustSelectAnExpenseTemplate, 0, true, false, null, '');
    //             return;
    //         }

    //         defaultValueSetAsync(true);
    //         sendMessage(0, globalSettings?.messages?.processesCompletedSuccessfully?.[languageObj?.id], 0, true, false, null, '');
    //     } catch(ex){
    //         sendMessage(-1, `Method: localExpenseTemplateAddPostAsync\n${ex?.message}`, 0, true, false);
    //     }
    // }
    //#endregion Old code

    const controlsStatusSet = ({ processType = 0, subMethod = '', }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    for (let ctrStr in controls) {
                        const objStr = ['buttons', 'spinners', 'icons'];
                        if (objStr?.includes(ctrStr)) {
                            for (let propStr in controls?.[ctrStr]) {
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.removeClass();
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.addClass(controls?.[ctrStr]?.[propStr]?.className);
                            }
                        }
                    }
                    break;
                case 1:
                    //$(`#${controls?.buttons?.save?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled} ${settings.react.html.button.classes.progress}`);
                    $(`#${controls?.icons?.back?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.back?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                default:
                    break;
            }

            //#region controls
            // $(`#${controls?.inputs?.description?.id}`)?.attr('readOnly', (processType !== 0));
            // $(`#${controls?.inputs?.date?.id}`)?.attr('readOnly', (processType !== 0));
            // $(`#${controls?.inputs?.expenseTemplateTotal?.id}`)?.attr('readOnly', (processType !== 0));
            //#endregion controls

            //#region url (register / passwords)
            // $(`#${controls?.urls?.forgotYourPassword?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlForgotPassword));
            // $(`#${controls?.urls?.userRegister?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlUserRegister));
            // $(`#${controls?.urls?.registerStatus?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlRegisterStatus));
            //#endregion url (register / passwords)

            //#region url (rechaptcha)
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.react?.reCAPTCHA?.urlPrivaciConditions));
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('target', (processType !== 0 ? '' : '_blank'));
            //#endregion url (rechaptcha)

            //#region urls
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
            //     'href': (processType !== 0 ? urlStop : globalSettings?.app?.reCAPTCHA?.urlPrivaciConditions),
            //     'target': (processType !== 0 ? '' : '_blank'),
            // });
            //#endregion urls

            //#region dataTable buttons
            // btnExcel.node.disabled = processType !== 0;
            // btnPdf.node.disabled = processType !== 0;
            //#endregion dataTable buttons

            //#region dataTable
            $(`#${controls?.dataTables?.expenseTemplates?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.dataTables?.expenseTemplates?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0));
            //#endregion dataTable

            if (processType !== 0) {
                $(`#${controls?.buttons?.back?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
                $(`#${controls?.buttons?.close?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console?.error(response);
        }
        return response;
    }

    useEffect(() => {
        dataGetAsync({ subMethod: 'form - onLoad', });
    }, []) //eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods

    return (
        <Modal backdrop='static'
            show={showModal}
            onHide={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - onHide', })}>
            <Modal.Header>
                <Modal.Title>
                    <img alt={globalSettings?.labels?.expenseTemplates?.[languageObj?.id]}
                        style={styles?.cardHeaderLogo}
                        src={globalSettings?.images?.expenseConceptsLogo}></img> - {globalSettings?.labels?.expenseTemplates?.[languageObj?.id]} ({globalSettings?.labels?.select?.[languageObj?.id]?.toLowerCase()})
                </Modal.Title>
                <button id={controls?.buttons?.close?.id}
                    className={controls?.buttons?.close?.className}
                    type='button'
                    data-dismiss='modal'
                    aria-label='Close'
                    onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - onClose', })}>
                </button>
            </Modal.Header>
            <Modal.Body>
                {/* <form onSubmit={(e) => localExpenseTemplateAddPostAsync(e)}> */}
                {/* <form>
                    <div className='card card-outline card-primary shadow-lg'> */}

                {/*header*/}
                {/* <div className='card-header'>
                            <h6 className='card-title'>
                                <img alt={globalSettings?.labels?.expenseTemplates?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={globalSettings?.images?.expenseConceptsLogo}></img> - {globalSettings?.labels?.expenseTemplates?.[languageObj?.id]}
                            </h6>
                        </div>  */}
                {/*card header*/}

                {/*body*/}
                {/* <div className='card-body'>
                    <div className='row'>
                        <div className='col-md-12'>
                            <div className={globalSettings?.html?.dataTables?.formats?.tableResponsiveSm}>
                                <table id={dtTemplatesId} className={globalSettings?.html?.dataTables?.formats?.smStripedBordered}></table>
                            </div>
                        </div>
                    </div>
                </div>  */}
                {/*card body*/}

                <div className='row'>
                    <div className='col-md-12'>
                        <div className={globalSettings?.html?.dataTables?.formats?.tableResponsiveSm}>
                            <table id={dtTemplatesId} className={globalSettings?.html?.dataTables?.formats?.smStripedBordered}></table>
                        </div>
                    </div>
                </div>

                {/*footer*/}
                {/* <div className='card-footer'>
                    <div className='form-group text-right'>
                        <button className='btn btn-outline-success mx-1'
                            tooltip='tooltip'
                            title={globalSettings?.labels?.close?.[languageObj?.id]}
                            type='reset'
                            onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - btnClose', })}>
                            <i className={globalSettings?.icons?.arrowCircleLeft}></i>
                        </button>
                    </div>
                </div> */}

                {/* </div>
                </form> */}
            </Modal.Body>

            <Modal.Footer>
                <div className='form-group text-right'>
                    <button id={controls?.buttons?.back?.id}
                        className={controls?.buttons?.back?.className}
                        tooltip='tooltip'
                        title={globalSettings?.labels?.close?.[languageObj?.id]}
                        type='button'
                        onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - btnClose', })}>
                        <i id={controls?.icons?.back?.id} className={controls?.icons?.back?.className} /> <span id={controls?.spinners?.back?.id} className='' aria-hidden='true'></span>
                    </button>
                </div>
            </Modal.Footer>
        </Modal>
    )
}